import React, { useState } from 'react';
import { useAsObservableSource } from 'mobx-react-lite';
import { observer } from 'src/utils/mobx-react';
import { ButtonsContainer, ButtonWrapper } from 'src/components/CustomersBar/CustomerTab/BankingTab/components/PaymentsAdditions.style';
import moment from 'moment';

const DateFormat = 'YYYY-MM-DD';

class ButtonDateState {

    public constructor(private readonly props: ButtonDatePropsType) {
    }

    public handleChange = (): void => {
        const currDate = this.props.currDate === '' ? moment() : this.props.currDate;

        const newDate = moment(currDate, DateFormat).add(1, this.props.timePerioid);

        if (newDate.isValid() === false) {
            return;
        }

        this.props.onChange(newDate.format(DateFormat).toString());
    };
}

interface ButtonDatePropsType {
    currDate: string,
    timePerioid: moment.DurationInputArg2,
    onChange: (newDate: string) => void
}

const ButtonDate = observer('ButtonDate', (propsIn: ButtonDatePropsType) => {
    const props = useAsObservableSource(propsIn);
    const [state] = useState(() => new ButtonDateState(props));
    const { timePerioid } = props;

    return (
        <ButtonWrapper
            onClick={state.handleChange}
        >
            {timePerioid}
        </ButtonWrapper>
    );
});


interface DateAdditionsPropsTypes {
    currDate: string,
    options?: Array<moment.DurationInputArg2>,
    onChange: (newDate: string) => void
    handleClearInput: () => void
}

export const DateAdditions = observer('DateAdditions', (propsIn: DateAdditionsPropsTypes) => {
    const props = useAsObservableSource(propsIn);
    const { options = ['day','week','month'], onChange, currDate, handleClearInput } = props;

    const handleClear = (): void => {
        handleClearInput();
    };

    return (
        <ButtonsContainer data-test='date-additions'>
            {options.map(timePerioid => (
                <ButtonDate
                    key={timePerioid}
                    currDate={currDate}
                    onChange={onChange}
                    timePerioid={timePerioid}
                />
            ))}
            <ButtonWrapper
                key='clear-deposit'
                onClick={handleClear}
            >
                Clear
            </ButtonWrapper>
        </ButtonsContainer>
    );
});
